import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {environment} from '@environment/environment';
import {LoaderComponent} from '@components/loader/loader.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, LoaderComponent],
  templateUrl: './app.component.html',
  standalone: true,
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'xrsupport_fe';

  private translateService = inject(TranslateService);

  constructor() {
    this.translateService.setDefaultLang(environment.language_default);
  }
}